import {useCallback, useState} from 'react';
import {jobCleanupOld} from '../../api/callable/jobs';

export default function useCleanupOldJobs() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const cleanupOldJobs = useCallback(async () => {
    setLoading(true);
    setError(undefined);
    try {
      return await jobCleanupOld({});
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {cleanupOldJobs, loading, error};
}
